import React from 'react';

function PrivacyPolicy() {
  return (
    <div style={{
      maxWidth: '800px',
      margin: '0 auto',
      padding: '2rem',
      backgroundColor: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
    }}>
      <h1 style={{ 
        fontSize: '2.5rem', 
        marginBottom: '2rem', 
        color: '#212529',
        textAlign: 'center'
      }}>Pre Go Prep Privacy Policy</h1>
      <div style={{ color: '#212529', lineHeight: '1.6' }}>
        <section style={{ marginBottom: '2rem' }}>
          <p>At Pre Go Prep, we are committed to connecting equestrians with activities and events that enhance their experience with their horses. Your privacy is important to us, and we want to be transparent about the data we collect and how we use it.</p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>Information We Collect</h2>
          <h3>User-Provided Information</h3>
          <p>We collect information that you provide when using Pre Go Prep, such as when you:</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>Sign up for an account</li>
            <li>Register for an event</li>
            <li>Create an organization</li>
            <li>Communicate with others through our platform</li>
          </ul>
          <p>This may include personal details, horse-related data, media files (such as photos and videos), and usage details like event participation and location.</p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h3>Information from Others</h3>
          <p>We may collect data that others provide about you, including photos, videos, and messages shared on Pre Go Prep.</p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h3>Connections and Networks</h3>
          <p>We track your interactions with groups, connections, and partners within Pre Go Prep to enhance your experience.</p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h3>Device Information</h3>
          <p>We gather data from the devices you use to access Pre Go Prep, including:</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>Device type, operating system, and settings</li>
            <li>Location data via GPS, Wi-Fi, or Bluetooth</li>
            <li>Network and connection details, such as IP address and mobile carrier</li>
          </ul>
          <p>We may also use tracking tools such as the Meta (Facebook) Pixel, which helps us understand how users interact with our site and improve our advertising efforts. This tool collects information like which pages you visit, actions you take, and other browser or device-related data. This information may be shared with Meta to help us show you more relevant ads on Facebook and Instagram.</p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h3>Third-Party Data</h3>
          <p>We may receive additional information from third-party partners, including event organizers and service providers.</p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>How We Use Your Information</h2>
          <p>We use the collected data to:</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>Provide and improve our services, including event recommendations</li>
            <li>Personalize user experiences</li>
            <li>Communicate important updates, marketing materials, and event details</li>
            <li>Ensure platform security and prevent fraud</li>
            <li>Improve advertising relevance and campaign effectiveness</li>
            <li>Analyze site usage through tools such as Meta Pixel</li>
          </ul>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>Information Sharing</h2>
          <h3>With Other Users</h3>
          <p>Your shared content, such as event participation details, may be visible to event organizers and other users.</p>
          <h3>With Third-Party Partners</h3>
          <p>We collaborate with vendors, service providers, and partners who support Pre Go Prep operations, such as:</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>Payment processing</li>
            <li>Technical infrastructure</li>
            <li>Analytics and marketing services</li>
          </ul>
          <p>These third parties are required to protect your data in accordance with our privacy policy.</p>
          <h3>Business Transfers</h3>
          <p>If Pre Go Prep undergoes a merger, acquisition, or asset sale, your information may be transferred to the new entity.</p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>Children’s Privacy</h2>
          <p>Pre Go Prep does not permit users under 13 to create accounts. Parents or guardians may provide limited information for children to participate in events. We take special care to protect children’s data and allow parents to manage or delete such information upon request.</p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>Managing Your Data</h2>
          <p>Users can manage, update, or delete their information through account settings. Deleting an account will remove associated content, but shared information may remain visible to others.</p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>Legal Compliance and Safety Measures</h2>
          <p>We may access, preserve, and disclose your information as required by law or when necessary to:</p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem' }}>
            <li>Respond to legal requests</li>
            <li>Prevent fraud, security risks, or harm</li>
            <li>Enforce Pre Go Prep policies</li>
          </ul>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>Payment &amp; Subscription Information</h2>
          <p style={{ marginBottom: '0.75rem' }}>
            To provide paid subscription features (such as SMS reminders), we use a third-party payment processor,
            Stripe. When you subscribe, Stripe collects and processes your payment method details (for example, credit
            or debit card information). <strong>We do not store your full card number or full payment credentials on
            our servers.</strong>
          </p>
          <p style={{ marginBottom: '0.75rem' }}>
            We may collect and store: billing contact information (such as email address) if you provide it;
            subscription status (e.g. active, canceled, trialing); a unique identifier that links your account to our
            payment processor (Stripe customer ID); and transaction or invoice metadata that we receive from our
            payment processor (such as date and amount of charges, last four digits of your card, and invoice
            numbers).
          </p>
          <p style={{ marginBottom: '0.75rem' }}>
            We use this information to process payments, manage your subscription, prevent fraud, enforce our terms,
            and comply with legal obligations.
          </p>
          <p style={{ marginBottom: '0.75rem' }}>
            Stripe's collection and use of your payment information is governed by{' '}
            <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer">
              Stripe's Privacy Policy
            </a>
            . Stripe is certified under the PCI-DSS standards for handling card data.
          </p>
          <p style={{ marginBottom: '0.75rem' }}>
            <strong>Retention:</strong> We retain payment-related information for as long as your account is active
            and for seven (7) years after your subscription ends or your account is closed, for support, accounting,
            and legal compliance, or longer where required by law.
          </p>
        </section>
        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>Your Rights</h2>
          <p>
            You can manage your advertising preferences through your Facebook account settings, or opt out of certain
            tracking by visiting{' '}
            <a href="https://www.facebook.com/adpreferences" target="_blank" rel="noopener noreferrer">
              https://www.facebook.com/adpreferences
            </a>
            .
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>SMS Information &amp; Consent</h2>
          <p>
            When you provide your mobile phone number and explicitly opt in to receive SMS messages from Pre Go Prep,
            we collect and store:
          </p>
          <ul style={{ marginLeft: '2rem', marginTop: '1rem', marginBottom: '0.75rem' }}>
            <li>Your mobile phone number</li>
            <li>Your SMS opt-in status and the date and time of consent</li>
            <li>Records of SMS messages sent to your number</li>
          </ul>
          <p style={{ marginBottom: '0.75rem' }}>
            Pre Go Prep uses Twilio, a third-party messaging service provider, to deliver SMS messages on our behalf.
            Your phone number is shared with Twilio solely for the purpose of sending these messages and is protected in
            accordance with Twilio&apos;s privacy and security practices.
          </p>
          <p style={{ marginBottom: '0.75rem' }}>
            SMS messages are used only to provide race-day preparation reminders, such as estimated performance go
            times or therapeutic timing-related notifications. We do not sell, rent, or share your phone number for
            marketing purposes.
          </p>
          <p style={{ marginBottom: '0.75rem' }}>
          Message frequency may vary based on your race schedule and notification preferences.</p>
          <p style={{ marginBottom: '0.75rem' }}>
          Consent to receive SMS messages is not a condition of purchase.</p>
          <p style={{ marginBottom: '0.75rem' }}>
            You may opt out of SMS messages at any time by replying STOP to any message. For help, reply HELP or
            contact support through your account. After opting out, you will no longer receive SMS messages unless you
            re-subscribe.
          </p>
        </section>

        <section style={{ marginBottom: '2rem' }}>
          <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#1e40af' }}>Policy Updates</h2>
          <p>We may update this privacy policy from time to time. Changes will be posted on this page, and the effective date will be updated accordingly.</p>
        </section>
        <div style={{ 
          marginTop: '3rem', 
          padding: '1rem', 
          backgroundColor: '#f8fafc', 
          borderRadius: '8px',
          textAlign: 'center'
        }}>
          <p style={{ marginBottom: '1rem' }}>
            By using Pre Go Prep, you agree to our collection and use of information as described in this Privacy Policy.
          </p>
          <p style={{ color: '#64748b' }}>
            Last Updated: May 1, 2026
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy; 